import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/RoleManager`;;

function paramsToStringList(params) {
  let stringparams = "?";
  Object.entries(params).map(([key, value]) => {
    if (value != undefined && value != null)
      stringparams = stringparams + key + "=" + value + "&";
  })
  stringparams = stringparams.substr(0, stringparams.length - 1);
  return stringparams;
}

const ApiRoleManager = {
  getAllAdminRoles: (params) => {
    const url = `${baseServiceUrl}/getAllAdminRoles` + paramsToStringList(params);
    return ServiceApi.get(url, params);
  },
  updateRole: (params) => {
    const url = `${baseServiceUrl}/updateRole`;
    return ServiceApi.put(url, params);
  },
  createRole: (params) => {
    const url = `${baseServiceUrl}/createRole`;
    return ServiceApi.post(url, params);
  },
  getRoleById: (params) => {
    const url = `${baseServiceUrl}/getRoleById` + paramsToStringList(params);
    return ServiceApi.get(url, params);
  },



};

export default ApiRoleManager;
